import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { Bus, useTour } from '@orion.ui/orion';
import { ref } from 'vue';

export type TourOrderPipelineEmits = {};
export type TourOrderPipelineProps = {};

export default class TourOrderPipelineSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = { warnClient: false };

	readonly _tourOrderPipeline = ref<OrionTour>();

	get warnClient () { return this.state.warnClient }

	constructor (
		private props: TourOrderPipelineProps,
		private emits: TourOrderPipelineEmits,
	) {
		super();
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourOrderPipeline', this._tourOrderPipeline.value);
		this.registerBusEvent('tourOrderPipeline', (warnClient) => {
			this.state.warnClient = warnClient;
		});
	}

	returnToTourOrderDetails () {
		useTour('tourOrderPipeline').stop();
		useTour('tourOrderDetailsAgency').start();
	}

	scrollToId (id: string) {
		const elem = document.getElementById(id);
		elem?.scrollIntoView();
		return document.getElementById(id);
	}

	updateWarnClient () {
		Bus.emit('OrderDetailsSetup:orderPipelineWarnClient');
		useTour('tourOrderPipeline').stop();
	}

}
